import { cva } from 'class-variance-authority';

export const iconButtonVariants = cva(
  'group relative inline-flex shrink-0 items-center justify-center rounded-control text-content-primary ring-offset-background transition-colors duration-standard ease-standard focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-focus-ring focus-visible:ring-offset-2 disabled:pointer-events-none [@media(pointer:coarse)]:min-h-11 [@media(pointer:coarse)]:min-w-11',
  {
    variants: {
      variant: {
        ghost: '',
        secondary: '',
        outline: '',
        destructive: '',
      },
      size: {
        banner:
          'size-8 [@media(pointer:coarse)]:!min-h-8 [@media(pointer:coarse)]:!min-w-8',
        compact: 'size-10',
        default: 'size-10',
        touch: 'size-11',
      },
    },
    defaultVariants: {
      variant: 'ghost',
      size: 'default',
    },
  }
);

export const iconButtonSurfaceVariants = cva(
  'inline-flex items-center justify-center rounded-control transition-colors duration-standard ease-standard group-active:bg-neutral-interaction-pressed group-disabled:border-border-subtle group-disabled:bg-surface-foundation-subtle group-disabled:text-content-disabled group-data-[state=open]:bg-neutral-interaction-selected group-data-[state=open]:ring-1 group-data-[state=open]:ring-inset group-data-[state=open]:ring-neutral-interaction-selected-border group-aria-expanded:bg-neutral-interaction-selected group-aria-expanded:ring-1 group-aria-expanded:ring-inset group-aria-expanded:ring-neutral-interaction-selected-border',
  {
    variants: {
      variant: {
        ghost:
          '[@media(hover:hover)_and_(pointer:fine)]:group-hover:bg-neutral-interaction-hover',
        secondary:
          'bg-surface-foundation-subtle [@media(hover:hover)_and_(pointer:fine)]:group-hover:bg-neutral-interaction-hover',
        outline:
          'border border-border-control bg-surface-base [@media(hover:hover)_and_(pointer:fine)]:group-hover:border-border-strong [@media(hover:hover)_and_(pointer:fine)]:group-hover:bg-neutral-interaction-hover',
        destructive:
          'text-status-danger-foreground [@media(hover:hover)_and_(pointer:fine)]:group-hover:bg-neutral-interaction-hover',
      },
      size: {
        banner: 'size-8 [&_svg]:size-3.5',
        compact: 'size-8 [&_svg]:size-3.5',
        default: 'size-10 [&_svg]:size-4',
        touch: 'size-11 [&_svg]:size-[18px]',
      },
    },
    defaultVariants: {
      variant: 'ghost',
      size: 'default',
    },
  }
);

